import Client from './Requests/Client';
import DataAPI from './Requests/DataAPI';
import Device from './Requests/Device';
import Requests from './Requests/Handler';
import Incident from './Requests/Incident';
import Note from './Requests/Note';
import Tenant from './Requests/Tenant';
import TenantApp from './Requests/TenantApp';
import TenantSetting from './Requests/TenantSetting';
import Token from './Requests/Token';
import User from './Requests/User';
import UserApp from './Requests/UserApp';
import WelcomeEmail from './Requests/WelcomeEmail';

/* aliases */
const UserReq = User;

export {
    Client,
    DataAPI,
    Device,
    Incident,
    Note,
    Token,
    Requests,
    Tenant,
    TenantApp,
    TenantSetting,
    User,
    UserApp,
    WelcomeEmail,
    /* aliases */
    UserReq
};
